function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

function resolveValue(path, contexts) {
  const token = String(path || '').trim()
  if (!token) return ''
  if (token === '.') {
    const current = contexts[contexts.length - 1]
    return current == null ? '' : current
  }

  const parts = token.split('.')
  for (let index = contexts.length - 1; index >= 0; index -= 1) {
    let value = contexts[index]
    let found = true
    for (const part of parts) {
      if (value && typeof value === 'object' && part in value) {
        value = value[part]
        continue
      }
      found = false
      break
    }
    if (found) {
      return value
    }
  }

  return ''
}

function findSectionEnd(template, sectionName, startIndex) {
  let depth = 1
  let cursor = startIndex

  while (cursor < template.length) {
    const nextOpen = template.indexOf('{{#', cursor)
    const nextClose = template.indexOf('{{/', cursor)
    if (nextClose < 0) break

    if (nextOpen >= 0 && nextOpen < nextClose) {
      const tagEnd = template.indexOf('}}', nextOpen)
      if (tagEnd < 0) break
      const nestedName = template.slice(nextOpen + 3, tagEnd).trim()
      if (nestedName === sectionName) {
        depth += 1
      }
      cursor = tagEnd + 2
      continue
    }

    const tagEnd = template.indexOf('}}', nextClose)
    if (tagEnd < 0) break
    const nestedName = template.slice(nextClose + 3, tagEnd).trim()
    if (nestedName === sectionName) {
      depth -= 1
      if (depth === 0) {
        return { closeStart: nextClose, closeEnd: tagEnd + 2 }
      }
    }
    cursor = tagEnd + 2
  }

  throw new Error(`Section '${sectionName}' is not properly closed.`)
}

function renderTemplate(template, contexts) {
  let cursor = 0
  let output = ''

  while (cursor < template.length) {
    const start = template.indexOf('{{', cursor)
    if (start < 0) {
      output += template.slice(cursor)
      break
    }

    output += template.slice(cursor, start)
    const end = template.indexOf('}}', start)
    if (end < 0) {
      output += template.slice(start)
      break
    }

    const tag = template.slice(start + 2, end).trim()
    cursor = end + 2

    if (!tag) continue

    if (tag.startsWith('#')) {
      const sectionName = tag.slice(1).trim()
      const { closeStart, closeEnd } = findSectionEnd(template, sectionName, cursor)
      const sectionTemplate = template.slice(cursor, closeStart)
      const value = resolveValue(sectionName, contexts)

      if (Array.isArray(value)) {
        for (const item of value) {
          output += renderTemplate(sectionTemplate, [...contexts, item])
        }
      } else if (value && typeof value === 'object') {
        output += renderTemplate(sectionTemplate, [...contexts, value])
      } else if (value) {
        output += renderTemplate(sectionTemplate, [...contexts, value])
      }

      cursor = closeEnd
      continue
    }

    if (tag.startsWith('/')) {
      continue
    }

    output += escapeHtml(resolveValue(tag, contexts))
  }

  return output
}

export function renderPrintTemplateBody(templateHtml, payload = {}) {
  return renderTemplate(String(templateHtml || ''), [payload || {}])
}
